module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1027-73d1a10a0fe65987c47b3189551598ef.png";